import { render, staticRenderFns } from "./HistoricState.vue?vue&type=template&id=d126ac36&"
import script from "./HistoricState.vue?vue&type=script&lang=js&"
export * from "./HistoricState.vue?vue&type=script&lang=js&"
import style0 from "./HistoricState.vue?vue&type=style&index=0&id=d126ac36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports